import React from "react";
import styled from "styled-components";
import logo from "./logo.png";
import { Container, AccentFont, LogoImage } from "./Logo.styles";

interface LogoProps {
  onClick?: () => void;
}

const Logo: React.FC<LogoProps> = ({ onClick }) => {
  return (
    <Container onClick={onClick}>
      <LogoImage src={logo} alt="CemLife RealTime" />
      <span>
        CemLife <br />
        <AccentFont>RealTime</AccentFont>
      </span>
    </Container>
  );
};

export default Logo;
